/**
 * TOOJ PDP gallery thumbs → stock product media slider
 * - Desktop column layout: scroll to media (stacked). NEVER hide slides.
 * - Mobile / active carousel: safe slideTo by index / media-id.
 * - Never use [hidden] on slides (that breaks the gallery).
 */
(function () {
  function isDesktopColumn(slider) {
    if (!slider) return false;
    var media = slider.closest('.hdt-product-media');
    if (media && media.classList.contains('hdt-product-media__layout-column')) {
      return window.matchMedia('(min-width: 1150px)').matches;
    }
    // Theme disables embla on desktop column via breakpoints
    try {
      if (slider.emblaApi && typeof slider.emblaApi.canScrollNext === 'function') {
        return false;
      }
    } catch (e) {}
    return window.matchMedia('(min-width: 1150px)').matches &&
      !!(media && media.className.indexOf('layout-column') !== -1);
  }

  function getSlides(slider) {
    return Array.prototype.slice.call(
      slider.querySelectorAll('.hdt-slider__slide[data-media-id], .hdt-slider__slide.hdt-product__media-item')
    );
  }

  function findSlide(slider, mediaId, index) {
    var slides = getSlides(slider);
    if (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
          return { slide: slides[i], index: i };
        }
      }
    }
    if (typeof index === 'number' && slides[index]) {
      return { slide: slides[index], index: index };
    }
    return null;
  }

  function setActiveThumbs(thumbs, index, mediaId) {
    thumbs.forEach(function (btn, i) {
      var on = false;
      if (mediaId && btn.getAttribute('data-media-id')) {
        on = String(btn.getAttribute('data-media-id')) === String(mediaId);
      } else {
        on = i === index;
      }
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function scrollToSlide(slide) {
    if (!slide) return;
    try {
      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    } catch (e) {
      slide.scrollIntoView(true);
    }
  }

  function safeSlideTo(slider, index) {
    if (typeof index !== 'number' || index < 0) return false;
    try {
      if (typeof slider.slideTo === 'function') {
        slider.slideTo(index);
        return true;
      }
    } catch (e) {}
    try {
      if (slider.emblaApi && typeof slider.emblaApi.scrollTo === 'function') {
        slider.emblaApi.scrollTo(index);
        return true;
      }
    } catch (e2) {}
    return false;
  }

  function clickThemeThumb(row, mediaId, index) {
    var thumbRoot = row.querySelector('.hdt-product-media__thumb');
    if (!thumbRoot) return false;
    var themeThumbs = thumbRoot.querySelectorAll('.hdt-slider__slide[data-media-id], .hdt-slider__slide');
    var target = null;
    if (mediaId) {
      for (var i = 0; i < themeThumbs.length; i++) {
        if (String(themeThumbs[i].getAttribute('data-media-id')) === String(mediaId)) {
          target = themeThumbs[i];
          break;
        }
      }
    }
    if (!target && typeof index === 'number') target = themeThumbs[index];
    if (!target) return false;
    var clickable = target.querySelector('button, a, img') || target;
    try {
      clickable.click();
      return true;
    } catch (e) {
      return false;
    }
  }

  function goTo(row, slider, thumbs, btn) {
    var mediaId = btn.getAttribute('data-media-id');
    var index = parseInt(btn.getAttribute('data-slide-index'), 10);
    if (isNaN(index)) index = Array.prototype.indexOf.call(thumbs, btn);

    var found = findSlide(slider, mediaId, index);
    if (found) {
      index = found.index;
      mediaId = found.slide.getAttribute('data-media-id') || mediaId;
    }

    setActiveThumbs(thumbs, index, mediaId);

    // Desktop column = stacked images — scroll only, never hide / never slideTo
    if (isDesktopColumn(slider) || (slider.closest('.hdt-product-media__layout-column') && window.matchMedia('(min-width: 990px)').matches)) {
      if (found && found.slide) scrollToSlide(found.slide);
      return;
    }

    // Mobile / carousel: prefer theme thumb sync, then slideTo
    if (clickThemeThumb(row, mediaId, index)) return;
    if (safeSlideTo(slider, index)) return;
    if (found && found.slide) scrollToSlide(found.slide);
  }

  function initRow(row) {
    if (!row || row.getAttribute('data-tooj-thumbs-ready') === 'true') return;
    row.setAttribute('data-tooj-thumbs-ready', 'true');

    var thumbs = row.querySelectorAll('[data-tooj-thumb]');
    var slider =
      row.querySelector('.hdt-product-media__main hdt-slider') ||
      row.querySelector('hdt-slider.hdt-slider-parent') ||
      row.querySelector('.tooj-pdp-media-row__slider hdt-slider');

    if (!thumbs.length || !slider) return;

    // Recovery from older buggy JS that hid all but one slide
    var slidesAll = getSlides(slider);
    var hiddenCount = 0;
    slidesAll.forEach(function (slide) {
      if (slide.hasAttribute('hidden')) hiddenCount += 1;
    });
    if (hiddenCount > 0 && hiddenCount >= slidesAll.length - 1) {
      slidesAll.forEach(function (slide) {
        slide.removeAttribute('hidden');
      });
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        goTo(row, slider, thumbs, btn);
      });
    });

    function syncFromSlider() {
      var index = null;
      try {
        if (typeof slider.selectedScrollSnap === 'function') index = slider.selectedScrollSnap();
      } catch (e) {}
      try {
        if (index == null && slider.emblaApi && typeof slider.emblaApi.selectedScrollSnap === 'function') {
          index = slider.emblaApi.selectedScrollSnap();
        }
      } catch (e2) {}
      if (typeof index === 'number') {
        var slides = getSlides(slider);
        var mediaId = slides[index] ? slides[index].getAttribute('data-media-id') : null;
        setActiveThumbs(thumbs, index, mediaId);
      }
    }

    slider.addEventListener('slideChanged', function (event) {
      var index = event && typeof event.detail === 'number' ? event.detail : null;
      if (typeof index === 'number') {
        var slides = getSlides(slider);
        var mediaId = slides[index] ? slides[index].getAttribute('data-media-id') : null;
        setActiveThumbs(thumbs, index, mediaId);
        return;
      }
      syncFromSlider();
    });

    // IntersectionObserver: highlight thumb for visible stacked image (desktop column)
    if ('IntersectionObserver' in window) {
      var slides = getSlides(slider);
      if (slides.length > 1) {
        var io = new IntersectionObserver(
          function (entries) {
            if (!window.matchMedia('(min-width: 990px)').matches) return;
            var best = null;
            entries.forEach(function (entry) {
              if (entry.isIntersecting && entry.intersectionRatio > 0.45) {
                if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
              }
            });
            if (best && best.target) {
              var mediaId = best.target.getAttribute('data-media-id');
              var idx = slides.indexOf(best.target);
              setActiveThumbs(thumbs, idx, mediaId);
            }
          },
          { root: null, threshold: [0.45, 0.6] }
        );
        slides.forEach(function (s) {
          io.observe(s);
        });
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-tooj-media-row]').forEach(initRow);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
